export const dimensionFormField = {
  dimensionUnit: "dimensionUnit",
  height: "height",
  length: "length",
  weight: "weight",
  weightUnit: "weightUnit",
  width: "width",
};
